module.exports = __webpack_public_path__ + "img/hefei.7a2fedba.png";